module.exports = __webpack_public_path__ + "Flaticon.b823a6751ed1b18680a8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/app/global-css/fonts/font/Flaticon.ttf
// module id = ./src/app/global-css/fonts/font/Flaticon.ttf
// module chunks = main